import {
  REGISTER_REQUESTING,
  REGISTER_SUCCESS,
  REGISTER_ERROR,
} from './constants'

const initialState = {
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
  postData: {},
  type: REGISTER_REQUESTING,
}

const reducer = function registerReducer (state = initialState, action) {
  switch (action.type) {
    // Set the requesting flag and append a message to be shown
    case REGISTER_REQUESTING:
      return {
        ...state,
        type: action.type,
        requesting: true,
        successful: false,
        messages: [{ body: 'Đang xử lý...', time: new Date() }],
        errors: [],
        postData: action.payload,
      }

    // Successful?  Reset the login state.
    case REGISTER_SUCCESS:
      return {
        ...state,
        type: action.type,
        errors: [],
        messages: [{
          body: action.message,
          time: new Date(),
        }],
        requesting: false,
        successful: true,
      }

    // Append the error returned from our api
    // set the success and requesting flags to false
    case REGISTER_ERROR:
      return {
        ...state,
        type: action.type,
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
        messages: [],
        requesting: false,
        successful: false,
      }

    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/Pages/Register/reducer.js